module.exports = __webpack_public_path__ + "static/media/AUS.4357d65e.png";